import React from 'react';
import './bootcamp.css';
import b_creative from '../../../../img/b_creative.png';

const m_main = () => {
    return (
        <div className="b_main__wrap">
            <div className="b_main container">
                <div className="b_content">
                    <p className="b_main--data">Data Science Global Summit’22</p>
                    <h2 className="b_main--title">UNLOCK <span className="b_main--small">YOUR FULL POTENTIAL</span></h2>
                    <h1 className="b_main--title_main">Geekle-Bootcamp</h1>
                    <p className="b_main--data">April 11th, 2022</p>
                    <p className="m_main--desc">Kick-start your career in data science. Get the skills you need, taught by world-renowned experts.</p>
                </div>
                <div className="b_img_block">
                    <img className="b_main--img" src={b_creative} alt="" />
                </div>
                
            </div>
        </div>
    );
};

export default m_main;